import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { AuthGuard } from '@next/core-lib/authorization';

import { CropVarietySpecificNormListComponent } from './components/crop-variety-specific-norm/list/crop-variety-specific-norm-list.component';
/* eslint-disable-next-line max-len */
import { LegalNitrogenWorkingCoefficientListComponent } from './components/legal-nitrogen-working-coefficient/list/legal-nitrogen-working-coefficient-list.component';
import { PhosphateLegalNormListComponent } from './components/phosphate-legal-norm/list/phosphate-legal-norm-list.component';
/* eslint-disable-next-line max-len */
import { PhosphateLegalWorkingCoefficientListComponent } from './components/phosphate-legal-working-coefficient/list/phosphate-legal-working-coefficient-list.component';
import { ReportsComponent } from './components/reports/reports.component';
import { TotalNitrogenLegalNormListComponent } from './components/total-nitrogen-legal-norm/list/total-nitrogen-legal-norm-list.component';
import { PageTitles } from './shared/models';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/reports',
    pathMatch: 'full',
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.Import,
    },
  },
  {
    path: 'total-nitrogen-legal-norm',
    component: TotalNitrogenLegalNormListComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.TotalNitrogenLegalNorm,
    },
  },
  {
    path: 'crop-variety-specific-norm',
    component: CropVarietySpecificNormListComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.CropVarietySpecificNorm,
    },
  },
  {
    path: 'legal-nitrogen-working-coefficient',
    component: LegalNitrogenWorkingCoefficientListComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.TotalNitrogenLegalNorm,
    },
  },
  {
    path: 'phosphate-legal-working-coefficient',
    component: PhosphateLegalWorkingCoefficientListComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.PhosphateLegalNorm,
    },
  },
  {
    path: 'phosphate-legal-norm',
    component: PhosphateLegalNormListComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: PageTitles.PhosphateLegalNorm,
    },
  },
  ...coreRoutes,
];
